import { render } from "./ProfileRelationSubpage.vue?vue&type=template&id=a4122694&scoped=true"
import script from "./ProfileRelationSubpage.vue?vue&type=script&lang=js"
export * from "./ProfileRelationSubpage.vue?vue&type=script&lang=js"

import "./ProfileRelationSubpage.vue?vue&type=style&index=0&id=a4122694&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4122694"]])

export default __exports__